import { useQuery } from '@tanstack/react-query';
import type { UserRole } from '@axioncrm/shared';
import { api } from './api';

export interface Me {
  id: string;
  organizationId: string;
  role: UserRole;
  email: string;
  firstName: string;
}

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<Me>('/api/me'),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
